import { Text } from '@chakra-ui/react';
import { useEffect, useRef } from 'react';
import { useCountdown } from './use-coundown';

interface TimerCountdownProps {
    initialTime: number;
    label?: string;
    isStartByDefault?: boolean;
    onTimeRunOut?: () => void;
    formatString?: string;
}

export function TimerCountdown({
    initialTime,
    label = 'Time left',
    isStartByDefault = false,
    formatString,
    onTimeRunOut,
}: TimerCountdownProps) {
    const {
        formattedTime,
        startCountdown,
        resetCountdown,
    } = useCountdown({
        initialTime,
        onTimeUp: onTimeRunOut,
        formatString,
    });

    const hasStarted = useRef(false);

    useEffect(() => {
        if (isStartByDefault && !hasStarted.current) {
            startCountdown();
            hasStarted.current = true;
        } else if (!isStartByDefault && hasStarted.current) {
            resetCountdown();
            hasStarted.current = false;
        }
    }, [isStartByDefault, startCountdown]);

    return (
        <Text fontWeight="normal" fontSize="sm">
            {label}
            {': '}
            {formattedTime}
        </Text>
    );
}
